export default "__VITE_ASSET__B86chu6A__"